import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=221294dc&scoped=true&"
import script from "./SettingPanel.vue?vue&type=script&lang=js&"
export * from "./SettingPanel.vue?vue&type=script&lang=js&"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=221294dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221294dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221294dc')) {
      api.createRecord('221294dc', component.options)
    } else {
      api.reload('221294dc', component.options)
    }
    module.hot.accept("./SettingPanel.vue?vue&type=template&id=221294dc&scoped=true&", function () {
      api.rerender('221294dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/SettingPanel.vue"
export default component.exports